<template>
  <div :class="['card-item-info', { profile }]">
    <div class="card-set">{{ card.year }} {{ card.set }}</div>

    <div class="card-name">
      <span>{{ card.player }}</span>

      <span v-if="card.number"> #{{ card.number }}</span>
    </div>

    <card-item-chips
      :card="card"
      :profile="profile"
      :is-public="isPublic"
    >
      <slot />
    </card-item-chips>
  </div>
</template>

<script>
import CardItemChips from './CardItemChips';

export default {
  components: {
    CardItemChips,
  },

  props: {
    card: Object,
    profile: Boolean,
    isPublic: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-item-info {
  width: 100%;
  flex: 1;

  &:not(.profile) {
    @include ellipsis;
  }

  &.profile {
    .card-set,
    .card-name {
      white-space: normal;
    }
  }
}

.card-name {
  @include ellipsis;
  margin-bottom: $gp * .25;
  font-size: 22px;
  font-weight: bold;
  display: block;

  a {
    color: var(--theme-color);
  }
}

.card-set {
  @include ellipsis;
}
</style>
